import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/framework/services/base.service';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class RetailerPortalService extends BaseService{
  apiUrl: any;

  constructor() {
    super();
  }

  login(params: Params): Observable<any> {
    let url = this.apiUrl.login;
    return this.httpService.post(url, params);
  }


  verify(otp: number, username: string): Observable<any> {
    let url = this.apiUrl.verify;
    let body: any = {
      username: username,
      otp: otp
    }
    return this.httpService.post(url, body)
  }
  resendCode(params) {
    let url = this.apiUrl.resendCode;
    return this.httpService.post(url, params)
  }

  retailerUsernames(id) {
    return this.httpService.get(`${APIUrl.retailerUsernames}/${id}`) 
  }

  getCodeToAccesRetailerPortal(notification: any, retailerId: any){
    let url = APIUrl.getAccessVerifyCode;
    let params = new HttpParams().set('notification', notification).set('retailerUserId', retailerId)
    return this.httpService.postParams(url, params)
  }
  verifyCodeToAccessRetailerPortal(formData):Observable<any>{
    let url = APIUrl.submitOtpToAccessRetailer;
    return this.httpService.post(url, formData)
  }
}
